import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Marquee } from 'atoms/container/Marquee';
import { Vertical } from 'atoms/layout/flex';
import { BrandS } from 'atoms/typography';
import { DotsBackgroundBezel } from 'atoms/ui/DotsBackgroundBezel';
import { Img } from 'atoms/ui/Img';

import type { LogoBezelMarquee_competition } from './__generated__/index.graphql';

const Root = styled.div`
  margin-top: var(--double-unit);
`;

const LogoWrapper = styled(Vertical).attrs({ gap: 2, center: true })`
  height: 140px;
  width: 180px;
  padding: var(--triple-unit);
  text-align: center;
`;

const So5CompetitionLogo = styled(Img)`
  object-fit: contain;
`;

type League = {
  id?: string;
  displayName: string;
  pictureSecondaryUrl: string | null;
};

type Props = {
  leagues: League[];
};
export const LogoBezelMarquee = ({ leagues }: Props) => {
  return (
    <Root>
      {!!leagues.length && (
        <Marquee gap={5}>
          {leagues.map(
            ({ displayName, pictureSecondaryUrl }) =>
              pictureSecondaryUrl && (
                <DotsBackgroundBezel
                  mouseHoverEffect={{
                    color: 'var(--c-white)',
                    size: 50,
                    enabled: true,
                  }}
                  key={displayName}
                >
                  <LogoWrapper center>
                    <So5CompetitionLogo
                      src={pictureSecondaryUrl}
                      alt={displayName}
                      width="70"
                      height="70"
                      title={displayName}
                    />
                    <BrandS>{displayName}</BrandS>
                  </LogoWrapper>
                </DotsBackgroundBezel>
              )
          )}
        </Marquee>
      )}
    </Root>
  );
};

LogoBezelMarquee.fragments = {
  competition: gql`
    fragment LogoBezelMarquee_competition on Competition {
      id
      slug
      displayName
      pictureSecondaryUrl
    }
  ` as TypedDocumentNode<LogoBezelMarquee_competition>,
};
